import React, { useEffect } from 'react';
import {
    FormattedMessage,
    WrappedComponentProps,
    injectIntl,
    useIntl,
} from 'react-intl';
import { InvoiceOptions } from '../../../../models/invoice-options';
import AccountItem from '../../../common/account-item';
import Popover, { createPopover } from '../../../common/popover';
import SelectInput from '../../../inputs/select-input';

interface RepairWarrantyListProps {
    invoiceOptions: InvoiceOptions[];
    isReadOnly: boolean;
    onChange: (event: any, p: InvoiceOptions) => void;
    onCopy: (p: InvoiceOptions) => void;
}

const RepairWarrantyList = ({
    invoiceOptions,
    isReadOnly,
    onChange,
    onCopy,
}: RepairWarrantyListProps) => {
    const intl = useIntl();
    useEffect(() => {
        if (invoiceOptions.length > 1) {
            createPopover();
        }
    }, [invoiceOptions]);

    return (
        <>
            <div className="row gutter-top">
                <div className="col-sm-6">
                    <h4 className="gutter-left">
                        <FormattedMessage
                            id="Repair_Warranty_Preference_Directions"
                            defaultMessage="Preference selected will determine the repair warranty applied to out of warranty devices when they are sent in for repair. Repair Warranty selected will be the default repair warranty for this Bill To and Ship To combination."
                        />
                    </h4>
                </div>
            </div>
            <div className="row">
                <div className="col-md-12">
                    <hr />
                </div>
            </div>
            <div className="row">
                <div className="col-md-12">
                    {invoiceOptions.map((a, i) => (
                        <React.Fragment key={i}>
                            <div className="row">
                                <div className="col-md-12">
                                    <AccountItem account={a.shipToAccount} />
                                    <div className="col-md-6">
                                        <SelectInput
                                            name="defaultWarrantyPeriod"
                                            label={'Repair Warranty'}
                                            labelClassName=" "
                                            fieldClassName=" "
                                            value={a.defaultWarrantyPeriod}
                                            disabled={
                                                isReadOnly || a.buyingGroup
                                            }
                                            options={[
                                                {
                                                    text: intl.formatMessage({
                                                        id: '6_months',
                                                    }),
                                                    value: 0,
                                                },
                                                {
                                                    text: intl.formatMessage({
                                                        id: '12_months',
                                                    }),
                                                    value: 1,
                                                },
                                            ]}
                                            onChange={(e) => onChange(e, a)}
                                        />
                                    </div>
                                    {i === 0 &&
                                        invoiceOptions.length > 1 &&
                                        !isReadOnly &&
                                        !a.buyingGroup && (
                                            <div className="col-md-2 padding-top-lg float-right">
                                                <button
                                                    name="copyButton"
                                                    style={{
                                                        marginRight: '10px',
                                                    }}
                                                    className="btn btn-default"
                                                    onClick={() => onCopy(a)}
                                                >
                                                    <FormattedMessage
                                                        id="Copy_To_All"
                                                        defaultMessage="COPY TO ALL"
                                                    />
                                                </button>
                                                <Popover
                                                    content={intl.formatMessage(
                                                        {
                                                            id: 'Warranty_Preferences_Copy_All_Instructions',
                                                        }
                                                    )}
                                                />
                                            </div>
                                        )}
                                </div>
                            </div>
                            {invoiceOptions.length > 1 &&
                                i < invoiceOptions.length - 1 && <hr />}
                        </React.Fragment>
                    ))}
                </div>
            </div>
        </>
    );
};

export default RepairWarrantyList;
